import { memo } from 'react';

import Box from '@mui/material/Box';

import {
  ScaffolderFormPaper,
  ScaffolderInputHeader,
} from '../../../components';
import { ClusterPicker } from '../components';
import { Cluster, ClusterConfiguration, DEFAULT_CLUSTER } from '../types';

export interface ApplicationSetClusterSectionProps {
  value: ClusterConfiguration | null;
  availableClusters: Cluster[];
  onChange: (value: ClusterConfiguration | null) => void;
  errors: string[];
  enableAppSetSupport?: boolean;
}

const ApplicationSetClusterSectionInner = ({
  value,
  availableClusters,
  onChange,
  errors,
  enableAppSetSupport,
}: ApplicationSetClusterSectionProps) => {
  return (
    <Box>
      <ScaffolderFormPaper>
        <ScaffolderInputHeader
          title="Cluster"
          description="Select the cluster and namespace for this ApplicationSet."
          variant="h5"
          divider
        />
        <ClusterPicker
          value={value ?? DEFAULT_CLUSTER}
          clusters={availableClusters}
          onChange={onChange}
          errors={errors}
          enableAppSetSupport={enableAppSetSupport}
        />
      </ScaffolderFormPaper>
    </Box>
  );
};

export const ApplicationSetClusterSection = memo(
  ApplicationSetClusterSectionInner,
);
